/**
 * --- KONSEP: HALAMAN LUPA PASSWORD ---
 * Halaman ini digunakan jika pengguna tidak bisa masuk karena lupa kata sandi.
 * Pengguna cukup memasukkan Email, dan sistem akan mengirimkan link untuk membuat password baru.
 */
import React from "react";
import { Link } from "react-router-dom";
import AuthLayout from "../../components/layout/AuthLayout";

const ForgotPassword = () => {
  return (
    <AuthLayout>
      <div className="w-full max-w-md">
        {/* AREA JUDUL & IKON */}
        <div className="mb-12 text-center">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-xl bg-surface-container-highest mb-6">
            <span className="material-symbols-outlined text-primary text-3xl">
              lock_reset
            </span>
          </div>
          <h1 className="font-headline text-3xl font-extrabold text-on-surface tracking-tight mb-3">
            Lupa Password
          </h1>
          <p className="text-on-surface-variant font-medium leading-relaxed">
            Masukkan email Anda untuk menerima link reset password.
          </p>
        </div>

        {/* KARTU FORMULIR */}
        <div className="bg-surface-container-lowest p-8 md:p-10 rounded-xl ambient-bloom">
          <form className="space-y-6">
            {/* Input Email */}
            <div className="space-y-2">
              <label
                className="font-label text-xs font-semibold uppercase tracking-wider text-on-surface-variant px-1"
                htmlFor="email"
              >
                Email
              </label>
              <div className="relative group">
                <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none text-outline-variant group-focus-within:text-primary transition-colors">
                  <span className="material-symbols-outlined text-[20px]">
                    mail
                  </span>
                </div>
                {/* Kotak isian email yang akan dikirim link resetnya */}
                <input
                  className="w-full pl-11 pr-4 py-3.5 bg-surface-container-highest border-none rounded-xl focus:ring-2 focus:ring-primary-fixed-dim focus:bg-surface-container-lowest transition-all duration-200 text-on-surface placeholder:text-outline/60 font-medium"
                  id="email"
                  name="email"
                  placeholder="your@email.com"
                  required
                  type="email"
                />
              </div>
            </div>

            {/* Tombol Eksekusi Kirim Link */}
            <button
              className="w-full py-4 px-6 bg-gradient-to-br from-primary to-primary-container text-on-primary font-headline font-bold rounded-xl shadow-lg shadow-primary/20 hover:shadow-xl hover:shadow-primary/30 active:scale-[0.98] transition-all duration-150 flex items-center justify-center gap-2 group"
              type="submit"
            >
              <span>Kirim Link Reset</span>
              <span className="material-symbols-outlined text-lg group-hover:translate-x-1 transition-transform">
                arrow_forward
              </span>
            </button>
          </form>

          {/* Tautan untuk kembali ke halaman login */}
          <div className="mt-8 text-center pt-6 border-t border-outline-variant/10">
            <Link
              className="inline-flex items-center gap-2 text-primary font-semibold hover:text-on-primary-fixed-variant transition-colors duration-150 group"
              to="/login"
            >
              <span className="material-symbols-outlined text-[18px]">
                chevron_left
              </span>
              <span className="text-sm">Kembali ke Login</span>
            </Link>
          </div>
        </div>
      </div>
    </AuthLayout>
  );
};

export default ForgotPassword;
